module.exports = __webpack_public_path__ + "static/logo1-20baeacb3dc451d6d3447f8148ffb621.svg";